import React from 'react';

const NotFoundPage = () => {
  return (
    <div className="p-8 text-center">
      <h1 className="text-4xl font-bold">404</h1>
      <p className="mt-4">Page not found</p>
    </div>
  );
};

export default NotFoundPage;